define('SageDotCom/DataLayer/Events/Ccaas/ccaasTracking',[
        "SageDotCom/DataLayer/Events/eventBase"
    ],
    function (EventBase) {
        function CcaasTracking(eventName) {
            EventBase.call(this);

            this.props = {
                'event': "genesys",
                'event_name': eventName,
                'chat_name': "genesys"
            };
        }
        CcaasTracking.prototype = Object.create(EventBase.prototype);
        return CcaasTracking;
    });
